import { Briefcase } from 'lucide-react';
import { OpportunityCreate } from './OpportunityCreate';
import { OpportunityEdit } from './OpportunityEdit';
import { OpportunityList } from './OpportunityList';
import { OpportunityShow } from './OpportunityShow';

export const opportunities = {
    list: OpportunityList,
    create: OpportunityCreate,
    edit: OpportunityEdit,
    show: OpportunityShow,
    icon: Briefcase,
    recordRepresentation: 'reference',
};
